/**
 *
 * Icon
 *
 */
import React from 'react';
import classnames from 'classnames';

var Icon = function Icon(_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      iconType = _ref.iconType;
  return React.createElement("span", {
    className: classnames('icon', 'fil-icon', className, variant ? "fil-icon-".concat(iconType, "-").concat(variant) : "fil-icon-".concat(iconType))
  }, React.createElement("span", {
    className: "show-for-sr"
  }, iconType));
};
/* istanbul ignore next */


Icon.defaultProps = {
  iconType: 'search',
  forwardRef: function forwardRef() {}
};
Icon.displayName = 'Icon';
export default Icon;